import { api } from './api'

const API_BASE = `${import.meta.env.VITE_API_URL}/api/v1`

export const pdfServices = {
  generateInvoice: (visitId, visitType) => {
    return api.get(`${API_BASE}/pdf/invoice`, {
      params: { visit_id: visitId, visit_type: visitType },
      responseType: 'blob',
    })
  },

  generatePrescriptionInvoice: (visitId, visitType) => {
    return api.get(`${API_BASE}/pdf/prescription-invocie`, {
      params: { visit_id: visitId, visit_type: visitType },
      responseType: 'blob',
    })
  },

  generateInpatientReport: (visitId) => {
    return api.get(`${API_BASE}/pdf/inpatient-report`, {
      params: { visit_id: visitId, visit_type: 'inpatient' },
      responseType: 'blob',
    })
  },

  generateVisitReports: (params = {}) => {
    return api.get(`${API_BASE}/pdf/visit-reports`, {
      params,
      responseType: 'blob',
    })
  },

  generateClientDetails: (params = {}) => {
    return api.get(`${API_BASE}/pdf/client-details`, {
      params,
      responseType: 'blob',
    })
  },

  generatePosInvoicePdf: (invoiceId) => {
    return api.get(`${API_BASE}/invoices/${invoiceId}/pdf`, {
      responseType: 'blob',
    })
  },
}
